import PropTypes from 'prop-types';
import cn from 'classnames';

import { ItalicizedQuote } from 'Pages/TeamDashboard/CreateReview/components/ItalicizedQuote';

import { USER_JOURNEY_LABELS } from 'utlis/constants';
import { JOURNEY_MAP_CATEGORIES } from 'utlis/constants';
import { CATEGORY_IMAGE_MAPPING } from 'utlis/constants';

import styles from './styles.module.scss';

export const JourneyMapCard = ({
  data,
  onRollingReviews,
}) => (
  <div
    className={cn(
      styles['feedback-box'],
      styles['journey-feedback'],
      {
        [styles['margin-top']]:
            data.title?.toLowerCase() === USER_JOURNEY_LABELS.CRITICAL_SUCCESS_FACTORS.toLowerCase()
            && !onRollingReviews,
      }
    )}
  >
    <p className={styles['journey-feedback-title']}>
      {data.label?.toLowerCase().includes('phase') && <img src={CATEGORY_IMAGE_MAPPING[data.title]} alt="icon" />}
      {' '}
      {data.title?.toLowerCase() === USER_JOURNEY_LABELS.CRITICAL_SUCCESS_FACTORS.toLowerCase()
        ? data.heading
        : data.title}
    </p>
    {data.title?.toLowerCase() === JOURNEY_MAP_CATEGORIES.userActions.toLowerCase()
      ? (
        <ol className={styles['journey-feedback-content']}>
          {data.content.map((item, ind) => (
            <li key={ind} className={styles['journey-feedback-item']}>
              <ItalicizedQuote text={item} />
            </li>
          ))}
        </ol>
      )
      : (
        <ul className={styles['journey-feedback-content']}>
          {data.content.map((item, ind) => (
            <li key={ind} className={styles['journey-feedback-item']}>
              <ItalicizedQuote text={item} />
            </li>
          ))}
        </ul>
      )}
  </div>
);

JourneyMapCard.propTypes = {
  data: PropTypes.object,
  onRollingReviews: PropTypes.bool,
};
